import axios from "axios";

export default axios.create({
  baseURL: "https://arb-trader.coinmatic.app/api"
});
